import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import query from '@/api/APIServices'
import { CompanyParams } from '@/interfaces/company'

export const GET_ALL_COMPANIES_QUERY_KEY = 'companies'
export const GET_COMPANY_QUERY_KEY = (companyId: number) => [
  'company',
  companyId,
]

export function useServerLogisticCompany() {
  const queryClient = useQueryClient()

  const getCompanies = () => {
    return useQuery({
      queryKey: [GET_ALL_COMPANIES_QUERY_KEY],
      queryFn: async () => {
        const response = await query.get('/cargo/company')
        return response.data
      },
    })
  }
  const getCompany = (expedientId: number) => {
    return useQuery({
      queryKey: [GET_COMPANY_QUERY_KEY, expedientId],
      queryFn: async () => {
        const response = await query.get(`/cargo/company/${expedientId}`)
        return response.data
      },
      enabled: !!expedientId,
    })
  }

  const createCompany = (data: CompanyParams) => {
    return useMutation({
      mutationFn: async () => {
        const response = await query.post('/cargo/company', data)
        return response.data
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [GET_ALL_COMPANIES_QUERY_KEY],
        })
      },
    })
  }

  const updateCompany = (companyId: number, data: any) => {
    return useMutation({
      mutationFn: async () => {
        const response = await query.put(`/cargo/company/${companyId}`, data)
        return response.data
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [
            GET_COMPANY_QUERY_KEY(companyId),
            GET_ALL_COMPANIES_QUERY_KEY,
          ],
        })
      },
    })
  }
  const deleteCompany = (expedientId: number) => {
    return useMutation({
      mutationFn: async () => {
        const response = await query.deleteAPI(`/company/${expedientId}`)
        return response.data
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [GET_ALL_COMPANIES_QUERY_KEY],
        })
      },
    })
  }
  return {
    getCompanies,
    getCompany,
    createCompany,
    updateCompany,
    deleteCompany,
  }
}
